import _                                                     from 'underscore';
import { ORGANIZATIONAL_ROLES, PROJECT_ROLES, SYSTEM_ROLES } from '../constants/ProductEnums';

export enum RolePolicyType {
    ADMIN_ACCESS            = 'ADMIN_ACCESS',
    PROJECT_ACCESS          = 'PROJECT_ACCESS',
    PROJECT_SURVEY_VIEW     = 'PROJECT_SURVEY_VIEW',
    PROJECT_MANAGE_ACCESS   = 'PROJECT_MANAGE_ACCESS',
    PROJECT_OBJECTIVES_VIEW = 'PROJECT_OBJECTIVES_VIEW',
    PROJECT_MAP_VIEW        = 'PROJECT_MAP_VIEW',
    USER_ACCESS             = 'USER_ACCESS',
    USER_PROFILE_VIEW       = 'USER_PROFILE_VIEW',
}

export enum RolePolicyContext {
    SYSTEM       = 'SYSTEM',
    ORGANIZATION = 'ORGANIZATION',
    PROJECT      = 'PROJECT',
}

export type RoleType = SYSTEM_ROLES | ORGANIZATIONAL_ROLES | PROJECT_ROLES;

export type RolePolicyDefinition = {
    key: RolePolicyType,
    context: RolePolicyContext,
    policies: RolePolicyItem[]
}

export type RolePolicyItem = {
    roleValue: RoleType,
    value: boolean
}

export class RoleAccessService {

    static ROLE_CONTEXTS = RolePolicyContext;

    static rolePolicies: RolePolicyDefinition[] = [
        {
            key:      RolePolicyType.ADMIN_ACCESS,
            context:  RolePolicyContext.SYSTEM,
            policies: [
                { roleValue: SYSTEM_ROLES.CORVALADMIN, value: true },
                { roleValue: SYSTEM_ROLES.ACCOUNTSADMIN, value: true },
                { roleValue: SYSTEM_ROLES.DECISIONENGINEADMIN, value: true },
                { roleValue: SYSTEM_ROLES.MEMBER, value: false },
            ]
        }, {
            key:      RolePolicyType.PROJECT_ACCESS,
            context:  RoleAccessService.ROLE_CONTEXTS.PROJECT,
            policies: [
                { roleValue: PROJECT_ROLES.ADMIN, value: true },
                { roleValue: PROJECT_ROLES.MEMBER, value: true },
                { roleValue: PROJECT_ROLES.VIEWER, value: true },
            ]
        }, {
            key:      RolePolicyType.PROJECT_SURVEY_VIEW,
            context:  RoleAccessService.ROLE_CONTEXTS.PROJECT,
            policies: [
                { roleValue: PROJECT_ROLES.ADMIN, value: true },
                { roleValue: PROJECT_ROLES.MEMBER, value: true },
                { roleValue: PROJECT_ROLES.VIEWER, value: true },
            ]
        }, {
            key:      RolePolicyType.PROJECT_MANAGE_ACCESS,
            context:  RoleAccessService.ROLE_CONTEXTS.PROJECT,
            policies: [
                { roleValue: PROJECT_ROLES.ADMIN, value: true },
                { roleValue: PROJECT_ROLES.MEMBER, value: false },
                { roleValue: PROJECT_ROLES.VIEWER, value: true },
            ]
        }, {
            key:      RolePolicyType.PROJECT_OBJECTIVES_VIEW,
            context:  RoleAccessService.ROLE_CONTEXTS.PROJECT,
            policies: [
                { roleValue: PROJECT_ROLES.ADMIN, value: true },
                { roleValue: PROJECT_ROLES.MEMBER, value: true },
                { roleValue: PROJECT_ROLES.VIEWER, value: true },
            ]
        }, {
            key:      RolePolicyType.PROJECT_MAP_VIEW,
            context:  RoleAccessService.ROLE_CONTEXTS.PROJECT,
            policies: [
                { roleValue: PROJECT_ROLES.ADMIN, value: true },
                { roleValue: PROJECT_ROLES.MEMBER, value: true },
                { roleValue: PROJECT_ROLES.VIEWER, value: true },
            ]
        }, {
            key:      RolePolicyType.USER_ACCESS,
            context:  RoleAccessService.ROLE_CONTEXTS.ORGANIZATION,
            policies: [
                { roleValue: ORGANIZATIONAL_ROLES.ADMIN, value: true },
                { roleValue: ORGANIZATIONAL_ROLES.MEMBER, value: true },
            ]
        }, {
            key:      RolePolicyType.USER_PROFILE_VIEW,
            context:  RoleAccessService.ROLE_CONTEXTS.ORGANIZATION,
            policies: [
                { roleValue: ORGANIZATIONAL_ROLES.ADMIN, value: true },
                { roleValue: ORGANIZATIONAL_ROLES.MEMBER, value: true },
            ]
        }
    ];

    /**
     * Determines whether a user's role has access to a role policy
     *
     * @param roleType String
     * @param policyKey String
     * @static
     */
    static roleHasPolicyAccess( roleType: RoleType = null, policyKey: RolePolicyType = null ){

        let rolePolicies = RoleAccessService.rolePolicies,
            rolePolicy,
            rolePolicyForType;

        if( !rolePolicies ){
            throw new Error( 'Roles / role policies have not been acquired or loaded!' );
        }

        if( roleType ){

            rolePolicy = _.findWhere( rolePolicies, { key: policyKey } );

            if( rolePolicy ){

                rolePolicyForType = _.findWhere( rolePolicy.policies, { roleValue: roleType } );

                return _.isString( roleType ) && ( _.isUndefined( rolePolicyForType ) ? false : rolePolicyForType.value );

            } else {

                console.error( `No such role policy with id = ${ roleType }` );
            }

        } else {

            console.error( `Specified role id (${ roleType }) does not exist.` );
        }

        return false;
    }
}
